export const TIMEOUT_MS = 180_000

// Ta sama lista co `app/backend/src/devices/device-categories.ts` — backend odrzuca każdy inny rodzaj.
export const DEVICE_CATEGORIES = ['CRANE', 'TOWER_CRANE', 'PORT_CRANE'] as const

export type DeviceCategory = (typeof DEVICE_CATEGORIES)[number]
